import styled from '@emotion/styled';

const StyledButton = styled.button`
  width: 100%;
  font-size: 16px;
  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 8px 0;
  max-height: 40px;
`;

const InputWrapper = styled.div`
  position: relative;
  width: 100%;
`;
const StyledInput = styled.input`
  width: 100%;
  font-size: 14px;
  border-radius: 6px;
  padding: 12px;
  border: 1px solid var(--dk-line, #e7e9ec);
  box-shadow: none;
  ::placeholder {
    color: var(--dk-text-dim, #b7bbc2);
  }
  :focus {
    outline: none;
  }
`;

const Layout = styled.div`
  position: absolute;
  width: 100%;
  top: 8px;
  display: flex;
  flex-direction: column;
  max-height: 220px;
  overflow-y: auto;
  background-color: var(--dk-bg, white);
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
`;

const ErrorContainer = styled.div`
  color: var(--dk-danger, #f55060);
  font-size: 12px;
  z-index: 12;
  padding-left: 8px;
`;

export { InputWrapper, StyledButton, StyledInput, Layout, ErrorContainer };
